import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import ArticleGql from '@/extensions/shop/store/graphql/queries/Article.gql';
import ArticlesGql from '@/extensions/shop/store/graphql/queries/Articles.gql';
import ScanArticlesGql from '@/extensions/shop/store/graphql/queries/ScanArticles.gql';
import ValidateSkuGql from '@/extensions/shop/store/graphql/queries/ValidateSku.gql';
import ArticlesPaginatedGql from '@/extensions/shop/store/graphql/queries/ArticlesPaginated.gql';
import CreateArticleGql from '@/extensions/shop/store/graphql/mutations/CreateArticle.gql';
import UpdateArticleGql from '@/extensions/shop/store/graphql/mutations/UpdateArticle.gql';
import DeleteArticleGql from '@/extensions/shop/store/graphql/mutations/DeleteArticle.gql';
import HistoryGQl from '@//extensions/shop/store/graphql/queries/ArticleStockHistory.gql';
import HistoryGQlPaginated from '@//extensions/shop/store/graphql/queries/ArticleStockHistoryPaginated.gql';

export default {
    fetchArticleHistory: (variables) => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: HistoryGQl,
                    variables
                })
                .then(({ data }) => {
                    resolve(data.CO_ArticleStockHistory)
                })
                .catch((err) => reject(err));
        })
    },
    fetchArticleHistoryPaginated: (data) => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: HistoryGQlPaginated,
                    // variables
                    variables: {
                        currentPage: data.page,
                        articleId: data.articleId,
                        stockId: data.stockId,
                        perPage: _.get(data, 'pageInfo.perPage', 20),
                        // order: _.get(data, 'variables.order', 'id'),
                        // direction: _.get(data, 'variables.direction', 'asc'),
                        // link: _.get(data, 'link.route', '/event-manager/booking/'),
                        // filters
                    }
                })
                .then(({ data }) => {
                    resolve(data.CO_ArticleStockHistoryPaginated)
                })
                .catch((err) => reject(err));
        })
    },
    validateSKU: (sku, shopID = null, excludedArticleIDs = null) =>
        new Promise((resolve, reject) => {
            let variables = { sku };
            if (shopID) variables.shop = parseInt(shopID);
            if (excludedArticleIDs && excludedArticleIDs.length) {
                variables.excludedArticles = excludedArticleIDs.map(id => parseInt(id));
            }

            apolloClient
                .query({
                    query: ValidateSkuGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateSku))
                .catch(err => reject(err));
        }),
    fetchArticlesPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: ArticlesPaginatedGql,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_article'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'updated_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        // link: _.get(data, 'link.route', '/sales/order/'),
                        filters
                    }
                })
                // .then(({ data }) => resolve(data.CO_ArticlesPaginated))
                .then(({ data }) => resolve(data.CO_ArticlesPaginated))
                .catch(err => reject(err));
        }),
    fetchArticles: (variables) => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ArticlesGql,
                    fetchPolicy: 'no-cache',
                    variables: _.removeDeepByKey(variables, '__typename')
                })
                .then(({ data }) => resolve(data.CO_Articles))
                .catch(err => reject(err));
        });
    },
    // Schlanke Variante: nur SKU, Attribute (propertyPivots) und ein Thumbnail –
    // ohne Preise/Bestände/Übersetzungen etc. Für die mobile Artikel-Liste.
    fetchScanArticles: (variables) => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ScanArticlesGql,
                    fetchPolicy: 'no-cache',
                    variables: _.removeDeepByKey(variables, '__typename')
                })
                .then(({ data }) => resolve(data.CO_Articles))
                .catch(err => reject(err));
        });
    },
    fetchArticle: (id, shopID = null, translation = false) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id), translation };
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: ArticleGql,
                    fetchPolicy: 'no-cache',
                    variables: _.removeDeepByKey(variables, '__typename')
                })
                .then(({ data }) => resolve(data.CO_Article))
                .catch(err => reject(err));
        });
    },
    findArticle: (variables, fetchPolicy = 'cache-first', context = undefined) => {
        return new Promise((resolve, reject) => {
            if (variables.id) variables.id = parseInt(variables.id);
            if (variables.shop) variables.shop = parseInt(variables.shop);

            apolloClient
                .query({
                    query: ArticleGql,
                    fetchPolicy,
                    variables: _.removeDeepByKey(variables, '__typename'),
                    context,
                })
                .then(({ data }) => resolve(data.CO_Article))
                .catch(err => reject(err));
        });
    },
    create: article => {
        if (article === undefined) throw new Error('required argument is missing');

        article = _.removeDeepByKey(article, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateArticleGql,
                    variables: { article }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_CreateArticle);
                })
                .catch(err => reject(err));
        });
    },
    update: article => {
        if (article === undefined) throw new Error('required argument is missing');

        article = _.removeDeepByKey(article, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateArticleGql,
                    variables: { article }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_UpdateArticle);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteArticleGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteArticle);
                })
                .catch(err => reject(err));
        });
    },
    noDeleteDialog: (value) => {
        if (value !== undefined) {
            localStorage.setItem('no-delete-dialog:coupon-article', value);
        } else {
            return localStorage.getItem('no-delete-dialog:coupon-article');
        }
    },
};
